import { Container, Grid, Tab, Tabs } from "@mui/material"
import { Suspense, lazy, useState } from "react"
import PreLoader from "../components/PreLoader"

// import BaseCourses from "../components/academic/BaseCourses"
// import Classes from "../components/academic/Classes"
// import Courses from "../components/academic/Courses"
// import Sections from "../components/academic/Sections"
// import BaseLessons from "../components/academic/BaseLessons"
// import Header from "../components/header/Header"
// import Lessons from "../components/academic/Lessons"
// import RollCallSearch from "../components/academic/RollCallSearch"

const BaseCoursesPage = lazy(() => import("../components/academic/BaseCourses/BaseCoursesPage"))
const Classes = lazy(() => import("../components/academic/Classes"))
const CoursesPage = lazy(() => import("../components/academic/Courses/CoursesPage"))
const SectionsPage = lazy(() => import("../components/academic/Sections/SectionsPage"))
const Header = lazy(() => import("../components/header/Header"))
const Lessons = lazy(() => import("../components/academic/Lessons"))
const RollCallSearch = lazy(() => import("../components/academic/RollCallSearch"))
const Exams = lazy(() => import("../components/academic/Exams"))
const GradesScores = lazy(() => import('../components/academic/GradesScores'))
const StandardsPerformance = lazy(() => import('../components/academic/StandardsPerformance/StandardsPerformance'))


export default function AcademicView() {
  const [tab, setTab] = useState<string>('baseCourses')

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTab(newValue)
  }

  const renderComponent = () => {
    switch (tab) {
      case 'baseCourses':
        return <BaseCoursesPage />
      case 'courses':
        return <CoursesPage />
      case 'sections':
        return <SectionsPage />
      case 'classes':
        return <Classes />
      case 'lessons':
        return <Lessons />
      case 'roll-call':
        return <RollCallSearch />
      case 'exams':
        return <Exams />
      case 'grades':
        return <GradesScores />
      case 'standards-performance':
        return <StandardsPerformance />
      default:
        return <BaseCoursesPage />
    }
  }

  return <Suspense fallback={<PreLoader />}>
    <Container maxWidth='xl'>
      <br />
      <Grid container spacing={1} maxHeight={'100vh'}>
        <Header title={'Academic'} name={''} />
        <Grid item xs={12}>
          <Tabs value={tab} onChange={handleTabChange} variant='scrollable' scrollButtons='auto'>
            <Tab id='academic-tab-base-courses' label='Base Courses' value='baseCourses' />
            <Tab id='academic-tab-courses' label='Courses' value='courses' />
            <Tab id='academic-tab-sections' label='Sections' value='sections' />
            <Tab id='academic-tab-classes' label='Classes' value='classes' />
            <Tab id='academic-tab-lessons' label='Lessons' value='lessons' />
            <Tab id='academic-tab-roll-calls' label='Roll Call' value='roll-call' />
            <Tab id='academic-tab-exams' label='Exams' value='exams' />
            <Tab id='academic-tab-grades' label='Grades' value='grades' />
            <Tab id='academic-tab-standards-performance' label='Standards Performance' value='standards-performance' />
          </Tabs>
        </Grid>
        {renderComponent()}
      </Grid>
    </Container>
  </Suspense>
}
